import TagManager from "react-gtm-module";
import uuidv1 from "uuid/v1";

// google tag manager

const PAGE_VIEW = "signupPageview";
const SIGNUP_COMPLETE = "ecommerce";

const GTM_pageview = (pageTitle, pagePath) => {
    try {
        TagManager.dataLayer({
            dataLayer: {
                event: PAGE_VIEW,
                pageTitle: pageTitle,
                pagePath: pagePath,
            },
        });
    } catch (error) {
        console.error("Couldn't update the google tag manager pageview");
    }
};

const GTM_signupComplete = cart => {
    const transactionId = uuidv1(); //we don't store transactions so just randomly generate one
    try {
        TagManager.dataLayer({
            dataLayer: {
                event: SIGNUP_COMPLETE,
                transactionId: transactionId,
                transactionAffiliation: "MailChannels Signup",
                transactionTotal: cart.total / 100,
                transactionTax: cart.tax,
                transactionProducts: cart.items.map(item => ({
                    name: item.plan.planName,
                    sku: item.id,
                    category: item.productHandle,
                    price: item.summary.total / 100,
                    quantity: 1,
                })),
            },
        });
    } catch (error) {
        console.error("Couldn't update the google tag manager ecommerce");
    }
};

export { GTM_pageview, GTM_signupComplete };
